export default __webpack_public_path__ + "images/ea4ad42b3bb046a7455d9123d1eea044.png";